"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// source: https://atlas.collegeboard.org/apricot/prod/4.5.25/api/CBStates.json
// as of Nov 1st 2023, the data from atlas.collegeboard is exactly the same as
// https://msreference.cds-nonprod.collegeboard.org/palm/getDomainV1?cbDomain=state
var _default = [{
  "code": "00",
  "descr": "NO ANSWER",
  "activeInd": "Y",
  "displayInd": "N",
  "sortOrder": null,
  "attributes": [{
    "name": "state_cd",
    "value": "00"
  }]
}, {
  "code": "99",
  "descr": "NO MAP",
  "activeInd": "Y",
  "displayInd": "N",
  "sortOrder": null,
  "attributes": [{
    "name": "state_cd",
    "value": "99"
  }]
}, {
  "code": "AL",
  "descr": "Alabama",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 1,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "01"
  }, {
    "name": "cb_region_cd",
    "value": "SRO"
  }, {
    "name": "ets_state_id",
    "value": "1"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "AL"
  }, {
    "name": "state_fips_cd",
    "value": "01"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "AK",
  "descr": "Alaska",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 2,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "02"
  }, {
    "name": "cb_region_cd",
    "value": "WRO"
  }, {
    "name": "ets_state_id",
    "value": "2"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "AK"
  }, {
    "name": "state_fips_cd",
    "value": "02"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "AZ",
  "descr": "Arizona",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 3,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "03"
  }, {
    "name": "cb_region_cd",
    "value": "WRO"
  }, {
    "name": "ets_state_id",
    "value": "3"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "AZ"
  }, {
    "name": "state_fips_cd",
    "value": "04"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "AR",
  "descr": "Arkansas",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 4,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "04"
  }, {
    "name": "cb_region_cd",
    "value": "SWRO"
  }, {
    "name": "ets_state_id",
    "value": "4"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "AR"
  }, {
    "name": "state_fips_cd",
    "value": "05"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "CA",
  "descr": "California",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 5,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "05"
  }, {
    "name": "cb_region_cd",
    "value": "WRO"
  }, {
    "name": "ets_state_id",
    "value": "5"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "CA"
  }, {
    "name": "state_fips_cd",
    "value": "06"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "CO",
  "descr": "Colorado",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 6,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "06"
  }, {
    "name": "cb_region_cd",
    "value": "WRO"
  }, {
    "name": "ets_state_id",
    "value": "6"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "CO"
  }, {
    "name": "state_fips_cd",
    "value": "08"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "CT",
  "descr": "Connecticut",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 7,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "07"
  }, {
    "name": "cb_region_cd",
    "value": "NERO"
  }, {
    "name": "ets_state_id",
    "value": "7"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "CT"
  }, {
    "name": "state_fips_cd",
    "value": "09"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "DE",
  "descr": "Delaware",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 8,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "08"
  }, {
    "name": "cb_region_cd",
    "value": "MSRO"
  }, {
    "name": "ets_state_id",
    "value": "8"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "DE"
  }, {
    "name": "state_fips_cd",
    "value": "10"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "DC",
  "descr": "District of Columbia",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 9,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "09"
  }, {
    "name": "cb_region_cd",
    "value": "MSRO"
  }, {
    "name": "ets_state_id",
    "value": "9"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "DC"
  }, {
    "name": "state_fips_cd",
    "value": "11"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "FL",
  "descr": "Florida",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 10,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "10"
  }, {
    "name": "cb_region_cd",
    "value": "SRO"
  }, {
    "name": "ets_state_id",
    "value": "10"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "FL"
  }, {
    "name": "state_fips_cd",
    "value": "12"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "GA",
  "descr": "Georgia",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 11,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "11"
  }, {
    "name": "cb_region_cd",
    "value": "SRO"
  }, {
    "name": "ets_state_id",
    "value": "11"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "GA"
  }, {
    "name": "state_fips_cd",
    "value": "13"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "HI",
  "descr": "Hawaii",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 12,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "12"
  }, {
    "name": "cb_region_cd",
    "value": "WRO"
  }, {
    "name": "ets_state_id",
    "value": "12"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "HI"
  }, {
    "name": "state_fips_cd",
    "value": "15"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "ID",
  "descr": "Idaho",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 13,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "13"
  }, {
    "name": "cb_region_cd",
    "value": "WRO"
  }, {
    "name": "ets_state_id",
    "value": "13"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "ID"
  }, {
    "name": "state_fips_cd",
    "value": "16"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "IL",
  "descr": "Illinois",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 14,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "14"
  }, {
    "name": "cb_region_cd",
    "value": "MRO"
  }, {
    "name": "ets_state_id",
    "value": "14"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "IL"
  }, {
    "name": "state_fips_cd",
    "value": "17"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "IN",
  "descr": "Indiana",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 15,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "15"
  }, {
    "name": "cb_region_cd",
    "value": "MRO"
  }, {
    "name": "ets_state_id",
    "value": "15"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "IN"
  }, {
    "name": "state_fips_cd",
    "value": "18"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "IA",
  "descr": "Iowa",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 16,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "16"
  }, {
    "name": "cb_region_cd",
    "value": "MRO"
  }, {
    "name": "ets_state_id",
    "value": "16"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "IA"
  }, {
    "name": "state_fips_cd",
    "value": "19"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "KS",
  "descr": "Kansas",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 17,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "17"
  }, {
    "name": "cb_region_cd",
    "value": "MRO"
  }, {
    "name": "ets_state_id",
    "value": "17"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "KS"
  }, {
    "name": "state_fips_cd",
    "value": "20"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "KY",
  "descr": "Kentucky",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 18,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "18"
  }, {
    "name": "cb_region_cd",
    "value": "SRO"
  }, {
    "name": "ets_state_id",
    "value": "18"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "KY"
  }, {
    "name": "state_fips_cd",
    "value": "21"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "LA",
  "descr": "Louisiana",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 19,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "19"
  }, {
    "name": "cb_region_cd",
    "value": "SRO"
  }, {
    "name": "ets_state_id",
    "value": "19"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "LA"
  }, {
    "name": "state_fips_cd",
    "value": "22"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "ME",
  "descr": "Maine",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 20,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "20"
  }, {
    "name": "cb_region_cd",
    "value": "NERO"
  }, {
    "name": "ets_state_id",
    "value": "20"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "ME"
  }, {
    "name": "state_fips_cd",
    "value": "23"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "MD",
  "descr": "Maryland",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 21,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "21"
  }, {
    "name": "cb_region_cd",
    "value": "MSRO"
  }, {
    "name": "ets_state_id",
    "value": "21"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "MD"
  }, {
    "name": "state_fips_cd",
    "value": "24"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "MA",
  "descr": "Massachusetts",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 22,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "22"
  }, {
    "name": "cb_region_cd",
    "value": "NERO"
  }, {
    "name": "ets_state_id",
    "value": "22"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "MA"
  }, {
    "name": "state_fips_cd",
    "value": "25"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "MI",
  "descr": "Michigan",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 23,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "23"
  }, {
    "name": "cb_region_cd",
    "value": "MRO"
  }, {
    "name": "ets_state_id",
    "value": "23"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "MI"
  }, {
    "name": "state_fips_cd",
    "value": "26"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "MN",
  "descr": "Minnesota",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 24,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "24"
  }, {
    "name": "cb_region_cd",
    "value": "MRO"
  }, {
    "name": "ets_state_id",
    "value": "24"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "MN"
  }, {
    "name": "state_fips_cd",
    "value": "27"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "MS",
  "descr": "Mississippi",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 25,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "25"
  }, {
    "name": "cb_region_cd",
    "value": "SRO"
  }, {
    "name": "ets_state_id",
    "value": "25"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "MS"
  }, {
    "name": "state_fips_cd",
    "value": "28"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "MO",
  "descr": "Missouri",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 26,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "26"
  }, {
    "name": "cb_region_cd",
    "value": "MRO"
  }, {
    "name": "ets_state_id",
    "value": "26"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "MO"
  }, {
    "name": "state_fips_cd",
    "value": "29"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "MT",
  "descr": "Montana",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 27,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "27"
  }, {
    "name": "cb_region_cd",
    "value": "WRO"
  }, {
    "name": "ets_state_id",
    "value": "27"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "MT"
  }, {
    "name": "state_fips_cd",
    "value": "30"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "NE",
  "descr": "Nebraska",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 28,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "28"
  }, {
    "name": "cb_region_cd",
    "value": "MRO"
  }, {
    "name": "ets_state_id",
    "value": "28"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "NE"
  }, {
    "name": "state_fips_cd",
    "value": "31"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "NV",
  "descr": "Nevada",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 29,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "29"
  }, {
    "name": "cb_region_cd",
    "value": "WRO"
  }, {
    "name": "ets_state_id",
    "value": "29"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "NV"
  }, {
    "name": "state_fips_cd",
    "value": "32"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "NH",
  "descr": "New Hampshire",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 30,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "30"
  }, {
    "name": "cb_region_cd",
    "value": "NERO"
  }, {
    "name": "ets_state_id",
    "value": "30"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "NH"
  }, {
    "name": "state_fips_cd",
    "value": "33"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "NJ",
  "descr": "New Jersey",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 31,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "31"
  }, {
    "name": "cb_region_cd",
    "value": "MSRO"
  }, {
    "name": "ets_state_id",
    "value": "31"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "NJ"
  }, {
    "name": "state_fips_cd",
    "value": "34"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "NM",
  "descr": "New Mexico",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 32,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "32"
  }, {
    "name": "cb_region_cd",
    "value": "SWRO"
  }, {
    "name": "ets_state_id",
    "value": "32"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "NM"
  }, {
    "name": "state_fips_cd",
    "value": "35"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "NY",
  "descr": "New York",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 33,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "33"
  }, {
    "name": "cb_region_cd",
    "value": "MSRO"
  }, {
    "name": "ets_state_id",
    "value": "33"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "NY"
  }, {
    "name": "state_fips_cd",
    "value": "36"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "NC",
  "descr": "North Carolina",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 34,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "34"
  }, {
    "name": "cb_region_cd",
    "value": "SRO"
  }, {
    "name": "ets_state_id",
    "value": "34"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "NC"
  }, {
    "name": "state_fips_cd",
    "value": "37"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "ND",
  "descr": "North Dakota",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 35,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "35"
  }, {
    "name": "cb_region_cd",
    "value": "MRO"
  }, {
    "name": "ets_state_id",
    "value": "35"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "ND"
  }, {
    "name": "state_fips_cd",
    "value": "38"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "OH",
  "descr": "Ohio",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 36,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "36"
  }, {
    "name": "cb_region_cd",
    "value": "MRO"
  }, {
    "name": "ets_state_id",
    "value": "36"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "OH"
  }, {
    "name": "state_fips_cd",
    "value": "39"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "OK",
  "descr": "Oklahoma",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 37,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "37"
  }, {
    "name": "cb_region_cd",
    "value": "SWRO"
  }, {
    "name": "ets_state_id",
    "value": "37"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "OK"
  }, {
    "name": "state_fips_cd",
    "value": "40"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "OR",
  "descr": "Oregon",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 38,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "38"
  }, {
    "name": "cb_region_cd",
    "value": "WRO"
  }, {
    "name": "ets_state_id",
    "value": "38"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "OR"
  }, {
    "name": "state_fips_cd",
    "value": "41"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "PA",
  "descr": "Pennsylvania",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 39,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "39"
  }, {
    "name": "cb_region_cd",
    "value": "MSRO"
  }, {
    "name": "ets_state_id",
    "value": "39"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "PA"
  }, {
    "name": "state_fips_cd",
    "value": "42"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "RI",
  "descr": "Rhode Island",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 40,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "41"
  }, {
    "name": "cb_region_cd",
    "value": "NERO"
  }, {
    "name": "ets_state_id",
    "value": "40"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "RI"
  }, {
    "name": "state_fips_cd",
    "value": "44"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "SC",
  "descr": "South Carolina",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 41,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "42"
  }, {
    "name": "cb_region_cd",
    "value": "SRO"
  }, {
    "name": "ets_state_id",
    "value": "41"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "SC"
  }, {
    "name": "state_fips_cd",
    "value": "45"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "SD",
  "descr": "South Dakota",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 42,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "43"
  }, {
    "name": "cb_region_cd",
    "value": "MRO"
  }, {
    "name": "ets_state_id",
    "value": "42"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "SD"
  }, {
    "name": "state_fips_cd",
    "value": "46"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "TN",
  "descr": "Tennessee",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 43,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "44"
  }, {
    "name": "cb_region_cd",
    "value": "SRO"
  }, {
    "name": "ets_state_id",
    "value": "43"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "TN"
  }, {
    "name": "state_fips_cd",
    "value": "47"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "TX",
  "descr": "Texas",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 44,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "45"
  }, {
    "name": "cb_region_cd",
    "value": "SWRO"
  }, {
    "name": "ets_state_id",
    "value": "44"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "TX"
  }, {
    "name": "state_fips_cd",
    "value": "48"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "UT",
  "descr": "Utah",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 45,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "46"
  }, {
    "name": "cb_region_cd",
    "value": "WRO"
  }, {
    "name": "ets_state_id",
    "value": "45"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "UT"
  }, {
    "name": "state_fips_cd",
    "value": "49"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "VT",
  "descr": "Vermont",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 46,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "47"
  }, {
    "name": "cb_region_cd",
    "value": "NERO"
  }, {
    "name": "ets_state_id",
    "value": "46"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "VT"
  }, {
    "name": "state_fips_cd",
    "value": "50"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "VA",
  "descr": "Virginia",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 47,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "48"
  }, {
    "name": "cb_region_cd",
    "value": "SRO"
  }, {
    "name": "ets_state_id",
    "value": "47"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "VA"
  }, {
    "name": "state_fips_cd",
    "value": "51"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "WA",
  "descr": "Washington",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 49,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "49"
  }, {
    "name": "cb_region_cd",
    "value": "WRO"
  }, {
    "name": "ets_state_id",
    "value": "48"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "WA"
  }, {
    "name": "state_fips_cd",
    "value": "53"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "WV",
  "descr": "West Virginia",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 50,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "50"
  }, {
    "name": "cb_region_cd",
    "value": "MRO"
  }, {
    "name": "ets_state_id",
    "value": "49"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "WV"
  }, {
    "name": "state_fips_cd",
    "value": "54"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "WI",
  "descr": "Wisconsin",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 51,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "51"
  }, {
    "name": "cb_region_cd",
    "value": "MRO"
  }, {
    "name": "ets_state_id",
    "value": "50"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "WI"
  }, {
    "name": "state_fips_cd",
    "value": "55"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "WY",
  "descr": "Wyoming",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 52,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "52"
  }, {
    "name": "cb_region_cd",
    "value": "WRO"
  }, {
    "name": "ets_state_id",
    "value": "51"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "WY"
  }, {
    "name": "state_fips_cd",
    "value": "56"
  }, {
    "name": "us_area_status_cd",
    "value": "10"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "AS",
  "descr": "American Samoa",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 53,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "53"
  }, {
    "name": "cb_region_cd",
    "value": "IRO"
  }, {
    "name": "ets_state_id",
    "value": "52"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "AS"
  }, {
    "name": "state_fips_cd",
    "value": "60"
  }, {
    "name": "us_area_status_cd",
    "value": "1"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "FM",
  "descr": "Micronesia",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 54,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "59"
  }, {
    "name": "cb_region_cd",
    "value": "IRO"
  }, {
    "name": "ets_state_id",
    "value": "52"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "FM"
  }, {
    "name": "state_fips_cd",
    "value": "64"
  }, {
    "name": "us_area_status_cd",
    "value": "3"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "FM"
  }]
}, {
  "code": "GU",
  "descr": "Guam",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 55,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "55"
  }, {
    "name": "cb_region_cd",
    "value": "IRO"
  }, {
    "name": "ets_state_id",
    "value": "52"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "GU"
  }, {
    "name": "state_fips_cd",
    "value": "66"
  }, {
    "name": "us_area_status_cd",
    "value": "1"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "MH",
  "descr": "Marshall Islands",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 56,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "58"
  }, {
    "name": "cb_region_cd",
    "value": "IRO"
  }, {
    "name": "ets_state_id",
    "value": "52"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "MH"
  }, {
    "name": "state_fips_cd",
    "value": "68"
  }, {
    "name": "us_area_status_cd",
    "value": "3"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "MH"
  }]
}, {
  "code": "MP",
  "descr": "Northern Mariana Islands",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 57,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "57"
  }, {
    "name": "cb_region_cd",
    "value": "IRO"
  }, {
    "name": "ets_state_id",
    "value": "52"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "MP"
  }, {
    "name": "state_fips_cd",
    "value": "69"
  }, {
    "name": "us_area_status_cd",
    "value": "1"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "PW",
  "descr": "Palau",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 58,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "60"
  }, {
    "name": "cb_region_cd",
    "value": "IRO"
  }, {
    "name": "ets_state_id",
    "value": "52"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "PW"
  }, {
    "name": "state_fips_cd",
    "value": "70"
  }, {
    "name": "us_area_status_cd",
    "value": "4"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "PW"
  }]
}, {
  "code": "UM",
  "descr": "U.S. Minor Outlying Islands",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 59,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "64"
  }, {
    "name": "cb_region_cd",
    "value": "IRO"
  }, {
    "name": "ets_state_id",
    "value": "52"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "UM"
  }, {
    "name": "state_fips_cd",
    "value": "74"
  }, {
    "name": "us_area_status_cd",
    "value": "2"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "VI",
  "descr": "Virgin Islands, U.S.",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 60,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "56"
  }, {
    "name": "cb_region_cd",
    "value": "IRO"
  }, {
    "name": "ets_state_id",
    "value": "55"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "VI"
  }, {
    "name": "state_fips_cd",
    "value": "78"
  }, {
    "name": "us_area_status_cd",
    "value": "1"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}, {
  "code": "AA",
  "descr": "Armed Forces Americas (Except Canada)",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 61,
  "attributes": [{
    "name": "cb_region_cd",
    "value": "IRO"
  }, {
    "name": "mail_only_ind",
    "value": "Y"
  }, {
    "name": "state_cd",
    "value": "AA"
  }, {
    "name": "us_area_status_cd",
    "value": "11"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "AA"
  }]
}, {
  "code": "AE",
  "descr": "Armed Forces Canada, Europe, Middle East, Africa",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 62,
  "attributes": [{
    "name": "cb_region_cd",
    "value": "IRO"
  }, {
    "name": "mail_only_ind",
    "value": "Y"
  }, {
    "name": "state_cd",
    "value": "AE"
  }, {
    "name": "us_area_status_cd",
    "value": "11"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "AE"
  }]
}, {
  "code": "AP",
  "descr": "Armed Forces Pacific",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 63,
  "attributes": [{
    "name": "cb_region_cd",
    "value": "IRO"
  }, {
    "name": "mail_only_ind",
    "value": "Y"
  }, {
    "name": "state_cd",
    "value": "AP"
  }, {
    "name": "us_area_status_cd",
    "value": "11"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "Y"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "AP"
  }]
}, {
  "code": "PR",
  "descr": "Puerto Rico",
  "activeInd": "Y",
  "displayInd": "Y",
  "sortOrder": 64,
  "attributes": [{
    "name": "asc_state_cd",
    "value": "40"
  }, {
    "name": "cb_region_cd",
    "value": "IRO"
  }, {
    "name": "ets_state_id",
    "value": "54"
  }, {
    "name": "mail_only_ind",
    "value": "N"
  }, {
    "name": "state_cd",
    "value": "PR"
  }, {
    "name": "state_fips_cd",
    "value": "72"
  }, {
    "name": "us_area_status_cd",
    "value": "1"
  }, {
    "name": "use_for_data_entry_ind",
    "value": "N"
  }, {
    "name": "use_for_mail_ind",
    "value": "Y"
  }, {
    "name": "usps_standardized_country_cd",
    "value": "US"
  }]
}];
exports.default = _default;